/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';

interface AddWithQuantityToReturnProps {
  setOpenAddProduct: (show: boolean) => void;
  addedProduct?: any;
  setReturnItemData?: any;
  returnItemData?: any;
  setSavedBarcodes?: any;
}

const AddWithQuantityToReturn = ({
  setOpenAddProduct,
  addedProduct,
  setReturnItemData,
  returnItemData
}: AddWithQuantityToReturnProps) => {
  const { t } = useTranslation();

  console.log('addedProduct', addedProduct);

  const dispatch: Dispatch<any> = useDispatch();

  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const inputRefQuantity = useRef<HTMLInputElement | any>();

  const onSubmit: SubmitHandler<FieldValues> = data => {
    setLoading(true);

    let integerPart = 0;
    let numerator = 0;
    let denominator = 0;

    const quantity = String(data?.quantity);

    if (quantity?.includes('/')) {
      [numerator, denominator] = quantity.split('/').map(Number);

      integerPart = numerator; // Whole number part
      // eslint-disable-next-line
      denominator = denominator; // Remainder of the division
    } else {
      integerPart = +quantity;
    }

    let integerPartRemainder = 0;
    let numeratorRemainder = 0;
    let denominatorRemainder = 0;

    const quantityStrRemainder = String(addedProduct?.current_balance);

    if (quantityStrRemainder?.includes('/')) {
      [numeratorRemainder, denominatorRemainder] = quantityStrRemainder
        .split('/')
        .map(Number);
      integerPartRemainder = numeratorRemainder;
    } else {
      integerPartRemainder = +quantityStrRemainder;
    }

    const sanitizedBarcode = addedProduct?.invoice_pid;

    const adjustQuantityRemainder =
      addedProduct?.measure_unit_kind_pid === 1
        ? integerPartRemainder * addedProduct?.package_quantity +
          denominatorRemainder
        : integerPartRemainder;

    const adjustedQuantity =
      addedProduct?.measure_unit_kind_pid === 1
        ? integerPart * addedProduct?.package_quantity + denominator
        : integerPart;

    if (!addedProduct || +quantity <= 0 || +adjustQuantityRemainder === 0) {
      dispatch(
        showAlert({
          title: t('quantity_is_not_enough')
        })
      );
      setLoading(false);
      return;
    }
    if (+adjustedQuantity > +adjustQuantityRemainder) {
      dispatch(
        showAlert({
          title: t('quantity_exceeds_remainder', {
            remainder: adjustQuantityRemainder
          })
        })
      );
      setLoading(false);
      return;
    }

    const updatedProductInvoiceData = [...returnItemData];

    const foundProductIndex = updatedProductInvoiceData.findIndex(
      item => +item?.invoice_pid === +sanitizedBarcode
    );

    if (foundProductIndex !== -1) {
      updatedProductInvoiceData[foundProductIndex].amount = quantity;
    } else {
      const createdData = {
        ...addedProduct,
        amount: quantity
      };

      updatedProductInvoiceData.push(createdData);
    }

    setReturnItemData(updatedProductInvoiceData);

    dispatch(
      showAlert({
        title: t('product_successfully_added'),
        type: 'success'
      })
    );
    setLoading(false);
    setOpenAddProduct(false);
  };

  useEffect(() => {
    if (inputRefQuantity.current) {
      inputRefQuantity.current.focus();
    }
  }, [inputRefQuantity.current]);

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col>
            <Controller
              name={`quantity`}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    ref={inputRefQuantity}
                    type="text"
                    placeholder={t('quantity')}
                    onFocus={e => e.target.select()}
                    isInvalid={!!errors.quantity}
                  />
                  <label htmlFor="floatingInputCustom">{t('quantity')}</label>
                  {errors.quantity && (
                    <Form.Control.Feedback type="invalid">
                      {t('required_field')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Button
          className="w-100"
          variant="primary"
          type="submit"
          loading={loading}
        >
          {t('add')}
        </Button>
      </Form>
    </div>
  );
};
export default AddWithQuantityToReturn;
